import { font } from '@chegg-ui/theme'
import styled from 'styled-components'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const FormTitleRow = styled.div`
  margin: 24px auto;
  text-align: left;
  width: 100%;
  max-width: 900px;
`

export const H1 = styled.h1.attrs({
  role: 'heading',
  'aria-level': 1,
})`
  display: inline;
  &&& {
    ${AspiraStack};
    font-weight: ${font.weight.bold};
    font-size: ${font.size.px42};
    line-height: 44px;

    @media (min-width: 621px) and (max-width: 1279px) {
      font-size: 2.25rem;
      line-height: 40px;
    }
    @media (max-width: 620px) {
      font-size: 1.875rem;
      line-height: 34px;
    }
  }
`
